<template>
  <div>
    <div v-if="playlist.length" style="margin-bottom: 40px;">
      <h1 style="margin-bottom: 15px;">Playlist</h1>
      <div>
        <ul class="watchlist unstyled">
          <li v-for="(entry, i) in playlist" :key="entry.id">
            <div class="flex">
              <span class="button mr-1">
                <i @click="remove_from_playlist( entry.id )" class="fa fa-minus-circle text-red-700"></i>
                <!--
                <img
                    src="http://localhost:3000/assets/picto/minus-74ac88ba465d494a120095101cbda88a821c6e8c4f60e43b30b6c80bfc9dd297.png"
                    width="25"/>
                -->
              </span>
              <span class="title">
                <a
                  data-remote="true"
                  :href="`http://localhost:3000/programm/agendas/${entry.id}`"
                  >{{ entry.title }}</a
                >
              </span>
            </div>

            <div v-if="entry.video_links">
              <vue-plyr v-for="(token,i) in entry.video_links.split('\n')" :key="i">
                <div v-if="true" class="plyr__video-embed" style="margin-bottom: 10px;">
                  <iframe
                    :src="`https://www.youtube.com/embed/${token}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`"
                    allowfullscreen allowtransparency allow="autoplay">
                  </iframe>
                </div>
              </vue-plyr>
            </div>

            <div v-for="media in entry.media_files" :key="media.id">
              <vue-plyr v-if="media.file_content_type.match('audio')">
                <audio class="audio-player" controls>
                  <source
                    :src="`http://localhost:3000${media.file_path}`"
                    type="audio/mp3"
                  />
                </audio>
              </vue-plyr>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="false">
      <h1 style="margin-bottom: 15px;">Benachrichtigung</h1>
      <p>
        Ja, ich will informiert werden, wenn ein neuer Audio- oder Video-Beitrag
        verfügbar ist.
      </p>
      <input type="text" placeholder="E-Mail Adresse" />
      <input type="submit" value="Benachrichtigung speichern" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  computed: {
    ...mapState(["playlist"]),
  },
  methods: {
    ...mapActions(['remove_from_playlist'])
  },
}
</script>

<style lang="scss" scoped>
.watchlist {
  li {
    margin-bottom: 5px;

    .fa {
      font-size: 22px;
    }
  }
}
input {
  margin-bottom: 10px !important;
}
</style>
